document.addEventListener("click", (e) => {
  const link = e.target.closest(".header__menu-link");
  if (!link) return;

  const summary = link.closest("summary");
  if (!summary) return;

  // verhindert: Klick toggelt Details
  e.preventDefault();
  e.stopPropagation();

  window.location.href = link.href;
});

// Desktop Hover: öffnet details beim Hover (weil Dawn Submenu meist per details[open] steuert)
(function () {
  const isDesktopHover = window.matchMedia("(hover: hover) and (pointer: fine)");

  function setup() {
    document.querySelectorAll(".header__inline-menu details").forEach((details) => {
      const summary = details.querySelector("summary");
      if (!summary) return;

      details.addEventListener("mouseenter", () => {
        if (!isDesktopHover.matches) return;
        details.open = true;
      });

      details.addEventListener("mouseleave", () => {
        if (!isDesktopHover.matches) return;
        details.open = false;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", setup);
})();
